import React from 'react';
import { connect } from 'react-redux';

import { IUserInfo } from '@src/model/user/User';
import { UserRoleEnum } from '@src/model/user/UserRole';
import LoginBusinessStore from '@src/service/business/login/loginBusinessStore';
import RoleUtils from '@src/service/util/role/RoleUtils';

export interface IAllowedUserRolesPublicProps {
  roles: UserRoleEnum[];
  fallback: string | React.ReactNode;
  children: React.ReactNode;
}
export interface IAllowedUserRolesStateProps {
  currentUser: IUserInfo;
}

type IAllowedUserRolesProps = IAllowedUserRolesPublicProps & IAllowedUserRolesStateProps;

export interface IAllowedUserRolesState {
  allowed: boolean;
}

/**
 * Component provides control logic on current user's roles.
 *
 * Checks if current user is allowed according to roles whitelist and renders children if true.
 * If not allowed, fallback element is rendered.
 *
 * This component uses RoleUtils.allowedRoles() for role checking.
 */
class AllowedUserRoles extends React.Component<IAllowedUserRolesProps, IAllowedUserRolesState> {
  state: IAllowedUserRolesState = {
    allowed: false,
  };

  componentDidMount() {
    this.check();
  }

  componentDidUpdate(previousProps: IAllowedUserRolesProps) {
    if (this.props !== previousProps) {
      this.check();
    }
  }

  render() {
    return <React.Fragment>{this.state.allowed ? this.props.children : this.props.fallback}</React.Fragment>;
  }

  private check() {
    this.setState({
      allowed: this.isAllowed(),
    });
  }

  private isAllowed(): boolean {
    if (this.props.currentUser == null) {
      console.warn('Cannot check user roles if current user is empty. This protection does not work on public pages.');
      return false;
    }

    // find if any of users roles appears in allowed roles list
    return RoleUtils.allowedRoles(this.props.roles, this.props.currentUser.roles);
  }
}

// `state` parameter needs a type annotation to type-check the correct shape of a state object but also it'll be used by "type inference" to infer the type of returned props
const mapStateToProps = (state: any): IAllowedUserRolesStateProps => ({
  // tutorList: TutorListBusinessStore.selectors.getTutorList(state),
  currentUser: LoginBusinessStore.selectors.getCurrentUser(state),
});

export default connect<IAllowedUserRolesStateProps, any, IAllowedUserRolesPublicProps>(mapStateToProps)(AllowedUserRoles);
